export default __webpack_public_path__ + "static/media/Airbolt.d1181d03.svg";